import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type { CurrentMember } from './types/member';

const request = createAppRequest();

export async function getCurrentMember(options?: ApiRequestOptions) {
  return request<CurrentMember>('/bff/iam-ui/members/me', {
    method: 'GET',
    ...(options || {}),
  });
}
